import "./ApartmentImport.scss";
import React, { useState,useRef, useEffect } from "react";
import { extractAllProjectsImages, processSourceJson } from "../../../lib/99acresImport.js";

import ReactJson from "react-json-view";
import { GenericMaster } from "../../../lib/genericProjectsMaster";
import CancelButton from "../../../components/buttons/cancelbutton/CancelButton.jsx";
import encryptedapiRequest from "../../../lib/encryptedapiRequest.js";
import apiRequest from './../../../lib/apiRequest';



/*
  Generic JSON Import Tool
*/

function ApartmentImport() {

  const folderInputRef = useRef();

  
  const AcresMaster = GenericMaster;

  const [jsonText, setJsonText] = useState("");
  const [logs, setLogs] = useState([]);
  const [preview, setPreview] = useState(null);
  const [payload, setPayload] = useState(null);

  // const log = (msg) => setLogs((prev) => [...prev, msg]);
  // const tempLogs = [];

  // const log = (msg) => {
  //   tempLogs.push(msg);
  // };

  const logsRef = useRef([]);
  const log = (msg) => {
    logsRef.current.push(msg);
  };





const [jobId, setJobId] = useState(null);
const [status, setStatus] = useState({});
const [total, setTotal] = useState(0);

useEffect(() => {
  if (!jobId) return;

  const interval = setInterval(async () => {
    const res = await fetch("/api/download/status", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ jobId }),
    });

    const data = await res.json();
    setStatus(data.status);

    // ✅ Stop polling when done
    const done = data.status.done || 0;
    const failed = data.status.failed || 0;

    if (done + failed === total) {
      clearInterval(interval);
      console.log("Download complete");
    }

  }, 2000); // every 2 seconds

  return () => clearInterval(interval);

}, [jobId, total]);














  /* ----------------------------------------------------------
      GET VALUE FROM NESTED PATH
  ---------------------------------------------------------- */






  /* ----------------------------------------------------------
      FIND VALUE USING json_attribute OR alias
  ---------------------------------------------------------- */






  /* ----------------------------------------------------------
      TYPE HANDLING
  ---------------------------------------------------------- */




  /* ----------------------------------------------------------
      VALIDATE JSON + BUILD PAYLOAD
  ---------------------------------------------------------- */



const validateJson = () => {

  logsRef.current = [];  // ✅ clear buffer
  setLogs([]);           // ✅ clear UI

  setPayload(null);

  try {

    log("Starting JSON validation...");
    const sourceJson = JSON.parse(jsonText);

    // setPreview(sourceJson);

    log("✔ JSON parsed successfully");

    // const result = processSourceJson(sourceJson);

    const result = processSourceJson({
      sourceJson,
      AcresMaster,
      log
    });

    log(`✔ Payload created with ${result.data.length} records`);

    const withImage=extractAllProjectsImages(sourceJson);

    // console.log("finaldata with image",withImage);

    // sourceJson.media=withImage;

    // setPreview(sourceJson)

    setPreview(withImage);

    setLogs([...logsRef.current]);

    // this contains extracted 99acres data what is relavant and required
    setPayload(result.data);


    // console.log("FINAL PAYLOAD", result.data);

  } catch (error) {

    log("❌ JSON Error: " + error.message);
    setPreview(null);
  }
};





const handleFolderUpload = async (event) => {
// this will create a combinedpayload file in that folder

console.log("folder upload triggered");

  logsRef.current = [];  // ✅ clear buffer
  setLogs([]);
  
  setPayload(null);
  console.log("🔥 HANDLE FOLDER UPLOAD TRIGGERED");

  const files = Array.from(event.target.files);

  const textFiles = files.filter(file =>
    file.name.toLowerCase().endsWith(".txt")
  );


  log(`📂 ${textFiles.length} text files found`);

  let combinedPayload = [];
  let validate = true;

  for (const file of textFiles) {

    try {

      log("Starting file processing...");
      const text = await file.text();
      const sourceJson = JSON.parse(text);

      log(`✔ Processing file: ${file.name}`);

      // const result = processSourceJson(sourceJson, file.name);
      const result = processSourceJson({
        sourceJson,
        AcresMaster,
        log,
        fileName: file.name
      });

      if (!result.validate) validate = false;

      combinedPayload.push(...result.data);


      // setPayload(combinedPayload);

      // console.log("FINAL PAYLOAD",combinedPayload);




    } catch (err) {

      validate = false;
      log(`❌ Error in file ${file.name}: ${err.message}`);
    }
  }

  log(`✔ Total records created: ${combinedPayload.length}`);

  setLogs([...logsRef.current]);
    
  setPayload({
    // validate,
     combinedPayload
  });
  console.log("FOLDER PAYLOAD", combinedPayload);
  // console.log("statuss :",projectStatuses)

  downloadJSONFile(combinedPayload);
};



const downloadJSONFile = (jsonObj) => {
// will save in downloads folder of user as combined.txt

  // Convert JSON to string
  const text = JSON.stringify(jsonObj, null, 2); // pretty format

  // Create a blob
  const blob = new Blob([text], { type: "text/plain" });

  // Create a download link
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "combined.txt";

  // Trigger download
  link.click();
};



const startDownload = async () => {

  const res = await apiRequest.post(
    "/projects/download",
    { projectId: "all" }, // ✅ this is the payload
    {
      headers: {
        "Content-Type": "application/json", // optional; Axios adds automatically
      },
    }
  );

  const data = res.data;
  console.log(data);
  setJobId(data.jobId);
  setTotal(data.total);


};




const handleSavetoDB = async (event) => {
// alert("now saving")

  console.log("sending payload ",preview)
    let res=null;
    // 4. Send with Axios—no manual Content-Type header
    try {
      // add new post
         res = await encryptedapiRequest.post('/projects/pasteprojects', preview, {
          withCredentials: true,    // ensure cookies/session get sent
        });

        console.log("response ",res)

      // const post = res.data;
      // const post = {
      //   ...res.data,
      //   images: res.data.images.map(img => img.image)
      // }

      } catch (error) {
        console.error(error);
      }

}

const handleImages = async (event) => {
console.log("Preview: ",preview)

}



useEffect(() => {
  return () => {
    // 🧹 cleanup on unload
    logsRef.current = [];
    setLogs([]);
    setPayload(null);
    setPreview(null);
  };
}, []);



const done = status.done || 0;
const pending = status.pending || 0;
const downloading = status.downloading || 0;
const failed = status.failed || 0;




  /* ----------------------------------------------------------
      UI
  ---------------------------------------------------------- */

  return (
    <div className="container mt-4 importPage">

      <div className="pageContent">

          <h2>Project JSON Import Tool</h2>

          <div className="mb-3 textPaste">

            <label className="form-label">Paste JSON Here:</label>

            <textarea
              className="form-control pasteText"
              rows={15}
              value={jsonText}
              onChange={(e) => setJsonText(e.target.value)}
            />
          </div>





          {preview && (
            <div className="treview">
              <ReactJson
                src={preview}
                collapsed={1}
                theme="monokai"
              />
            </div>
          )}

          <div className="logs">

            <h5>Logs:</h5>

            <div className="myLogs">

              {logs.map((l, i) => (
                <div key={i}>{l}</div>
              ))}
            </div>
          </div>



 <div className="showDownload">

    {jobId && (
      <div>
        <p>Job ID: {jobId}</p>
        <p>Total: {total}</p>
        <p>Done: {done}</p>
        <p>Downloading: {downloading}</p>
        <p>Pending: {pending}</p>
        <p>Failed: {failed}</p>

        <progress value={done + failed} max={total} />
      </div>
    )}
  </div>








      </div>


   


      <div className="mb-4 buttonContainer">

        <button
          className="btn btn-warning me-2"
          onClick={() => {
            if (folderInputRef.current) {
              folderInputRef.current.value = null; // ✅ reset BEFORE opening
              folderInputRef.current.click();
            }
          }}
        >
          Step 1 - Upload Folder
        </button>


        <button
          className="btn btn-primary me-2"
          onClick={validateJson}
        >
          Step 2 - View
        </button>

        <button className="btn btn-success" onClick={handleSavetoDB}>
          Step 3 - Save to DB
        </button>


        {/* <button className="btn btn-success" onClick={handleImages}>
          images
        </button> */}

        <button onClick={startDownload}>Step 4 - Start Download</button>


          <input
            type="file"
            webkitdirectory="true"
            directory="true"

            // webkitdirectory
            // directory
            multiple
            ref={folderInputRef}
            style={{ display: "none" }}
            onChange={(e) => {
              console.log("INPUT CHANGED");
              handleFolderUpload(e);
            }}
          />


          <CancelButton></CancelButton>


      </div>














    </div>
  );
}

export default ApartmentImport;